module.exports = __webpack_public_path__ + "static/media/location-placeholder.ca49cf6b.webp";